module.exports = __webpack_public_path__ + "static/img/news.08224a33.png";